// Auto-generated index of all Colors components

import Color_Brands from "./colors_components/Color_Brands.jsx";
import Color_CMYK from "./colors_components/Color_CMYK.jsx";
import Color_Converter from "./colors_components/Color_Converter.jsx";
import Color_Currentcolor from "./colors_components/Color_Currentcolor.jsx";
import Color_Flat_UI from "./colors_components/Color_Flat_UI.jsx";
import Color_Gradient from "./colors_components/Color_Gradient.jsx";
import Color_Groups from "./colors_components/Color_Groups.jsx";
import Color_HEX from "./colors_components/Color_HEX.jsx";
import Color_HSL from "./colors_components/Color_HSL.jsx";
import Color_HWB from "./colors_components/Color_HWB.jsx";
import Color_Hues from "./colors_components/Color_Hues.jsx";
import Color_Metro_UI from "./colors_components/Color_Metro_UI.jsx";
import Color_Mixer from "./colors_components/Color_Mixer.jsx";
import Color_NCol from "./colors_components/Color_NCol.jsx";
import Color_Names from "./colors_components/Color_Names.jsx";
import Color_Palettes from "./colors_components/Color_Palettes.jsx";
import Color_Picker from "./colors_components/Color_Picker.jsx";
import Color_Psychology from "./colors_components/Color_Psychology.jsx";
import Color_RGB from "./colors_components/Color_RGB.jsx";
import Color_Schemes from "./colors_components/Color_Schemes.jsx";
import Color_Shades from "./colors_components/Color_Shades.jsx";
import Color_Theory from "./colors_components/Color_Theory.jsx";
import Color_Values from "./colors_components/Color_Values.jsx";
import Color_W3CSS from "./colors_components/Color_W3CSS.jsx";
import Color_Wheels from "./colors_components/Color_Wheels.jsx";
import Color_Win8 from "./colors_components/Color_Win8.jsx";
import Colors_2016 from "./colors_components/Colors_2016.jsx";
import Colors_2017 from "./colors_components/Colors_2017.jsx";
import Colors_2018 from "./colors_components/Colors_2018.jsx";
import Colors_2019 from "./colors_components/Colors_2019.jsx";
import Colors_2020 from "./colors_components/Colors_2020.jsx";
import Colors_2021 from "./colors_components/Colors_2021.jsx";
import Colors_2024 from "./colors_components/Colors_2024.jsx";
import Colors_2025 from "./colors_components/Colors_2025.jsx";
import Colors_Analogous from "./colors_components/Colors_Analogous.jsx";
import Colors_Australia from "./colors_components/Colors_Australia.jsx";
import Colors_Complementary from "./colors_components/Colors_Complementary.jsx";
import Colors_Compound from "./colors_components/Colors_Compound.jsx";
import Colors_Crayola from "./colors_components/Colors_Crayola.jsx";
import Colors_Home from "./colors_components/Colors_Home.jsx";
import Colors_Monochromatic from "./colors_components/Colors_Monochromatic.jsx";
import Colors_NBS from "./colors_components/Colors_NBS.jsx";
import Colors_NCS from "./colors_components/Colors_NCS.jsx";
import Colors_Of_The_Year from "./colors_components/Colors_Of_The_Year.jsx";
import Colors_RAL from "./colors_components/Colors_RAL.jsx";
import Colors_Resene from "./colors_components/Colors_Resene.jsx";
import Colors_Triadic from "./colors_components/Colors_Triadic.jsx";
import Colors_UK from "./colors_components/Colors_UK.jsx";
import Colors_USA from "./colors_components/Colors_USA.jsx";
import Colors_X11 from "./colors_components/Colors_X11.jsx";
import Colors_XKCD from "./colors_components/Colors_XKCD.jsx";

const AllColorsComponents = {
  "<Color_Brands />": Color_Brands,
  "<Color_CMYK />": Color_CMYK,
  "<Color_Converter />": Color_Converter,
  "<Color_Currentcolor />": Color_Currentcolor,
  "<Color_Flat_UI />": Color_Flat_UI,
  "<Color_Gradient />": Color_Gradient,
  "<Color_Groups />": Color_Groups,
  "<Color_HEX />": Color_HEX,
  "<Color_HSL />": Color_HSL,
  "<Color_HWB />": Color_HWB,
  "<Color_Hues />": Color_Hues,
  "<Color_Metro_UI />": Color_Metro_UI,
  "<Color_Mixer />": Color_Mixer,
  "<Color_NCol />": Color_NCol,
  "<Color_Names />": Color_Names,
  "<Color_Palettes />": Color_Palettes,
  "<Color_Picker />": Color_Picker,
  "<Color_Psychology />": Color_Psychology,
  "<Color_RGB />": Color_RGB,
  "<Color_Schemes />": Color_Schemes,
  "<Color_Shades />": Color_Shades,
  "<Color_Theory />": Color_Theory,
  "<Color_Values />": Color_Values,
  "<Color_W3CSS />": Color_W3CSS,
  "<Color_Wheels />": Color_Wheels,
  "<Color_Win8 />": Color_Win8,
  "<Colors_2016 />": Colors_2016,
  "<Colors_2017 />": Colors_2017,
  "<Colors_2018 />": Colors_2018,
  "<Colors_2019 />": Colors_2019,
  "<Colors_2020 />": Colors_2020,
  "<Colors_2021 />": Colors_2021,
  "<Colors_2024 />": Colors_2024,
  "<Colors_2025 />": Colors_2025,
  "<Colors_Analogous />": Colors_Analogous,
  "<Colors_Australia />": Colors_Australia,
  "<Colors_Complementary />": Colors_Complementary,
  "<Colors_Compound />": Colors_Compound,
  "<Colors_Crayola />": Colors_Crayola,
  "<Colors_Home />": Colors_Home,
  "<Colors_Monochromatic />": Colors_Monochromatic,
  "<Colors_NBS />": Colors_NBS,
  "<Colors_NCS />": Colors_NCS,
  "<Colors_Of_The_Year />": Colors_Of_The_Year,
  "<Colors_RAL />": Colors_RAL,
  "<Colors_Resene />": Colors_Resene,
  "<Colors_Triadic />": Colors_Triadic,
  "<Colors_UK />": Colors_UK,
  "<Colors_USA />": Colors_USA,
  "<Colors_X11 />": Colors_X11,
  "<Colors_XKCD />": Colors_XKCD,
};

export default AllColorsComponents;
